
export const getStoreActions = (
  status,
  handleDelete,
  navigate,
  handleDeleteRequest,
  showModal,
  highest_role,
  handleProductOpenModal,
  handleRequestOpenModal,
  setDeleteModalVisible,
  setStoreToDelete,
  setIsRequestDelete,
  lang,
  currentLanguage,
  canDelete = true // false for `edit_only` roles: everything but delete
) => {
  if (status === 'approved') {
    if (highest_role === 'OWNER') {
      return [
        {
          icon: '/store/editStore.svg',
          className: 'edit',
          onClick: (row) => navigate(`/stores/update-store/${row.id}`),
          type: 'image',
        },
        // {
        //   icon: "/store/plusStore.svg",
        //   className: "add",
        //   onClick: (row) => console.log("Add", row),
        //   type: "image",
        // },
        ...(canDelete
          ? [
              {
                icon: '/store/trash.svg',
                className: 'delete',
                onClick: (row) => {
                  setStoreToDelete(row)
                  setIsRequestDelete(false)
                  setDeleteModalVisible(true)
                },
                type: 'image',
              },
            ]
          : []),
      ]
    } else if (highest_role === 'SUPERADMIN') {
      return [
        {
          text:currentLanguage?.storeActions?.view_product ,
          className: 'view-add-comments',
          onClick: (row) => handleProductOpenModal(row),
          type: 'text',
        },
        {
          icon: '/store/viewicon.svg',
          className: 'view',
          onClick: (row) => handleRequestOpenModal(row),
          type: 'image',
        },
        ...(canDelete
          ? [
              {
                icon: '/store/trash.svg',
                className: 'delete',
                onClick: (row) => {
                  setStoreToDelete(row)
                  setIsRequestDelete(false)
                  setDeleteModalVisible(true)
                },
                type: 'image',
              },
            ]
          : []),
      ]
    }
    else if( highest_role==="ADMIN"){
      return [
        {
          icon: '/store/editStore.svg',
          className: 'edit',
          onClick: (row) => navigate(`/stores/update-store/${row.id}`),
          type: 'image',
        }
      ]
    }
  } else if (status === 'rejected') {
    if (highest_role === 'SUPERADMIN') {
      return [
        {
          icon: '/store/chaticon.svg',
          // className: "delete",
          onClick: (row) => showModal(row),
          type: 'image',
        },
        {
          icon: '/store/viewicon.svg',
          // className: "delete",
          onClick: (row) => handleRequestOpenModal(row),
          type: 'image',
        },
        ...(canDelete
          ? [
              {
                icon: '/store/trash.svg',
                className: 'delete',
                onClick: (row) => {
                  setStoreToDelete(row)
                  setIsRequestDelete(true)
                  setDeleteModalVisible(true)
                },
                type: 'image',
              },
            ]
          : []),
      ]
    } else if (highest_role === 'OWNER') {
      return [
        {
          text: currentLanguage?.storeActions?.view_add_comments,
          className: 'view-add-comments',
          onClick: (row) => showModal(row),
          type: 'text',
        },
        {
          button: (row) => (
            <button
              className={`resubmit-btn ${
                row.resubmit_count >= 3 ? 'disabled' : ''
              }`}
              disabled={row.resubmit_count >= 3}
              type='button'
            >
              {currentLanguage?.storeActions?.resubmit} -{' '}
              <span className='text-FD853A text-14'>
                {' '}
                {row.resubmit_count}/3
              </span>
            </button>
          ),
          className: 'resubmit-btn',
          onClick: (row) => navigate(`/stores/resubmit-store/${row.id}`),
          type: 'button',
        },
        ...(canDelete
          ? [
              {
                icon: '/store/trash.svg',
                className: 'delete',
                onClick: (row) => {
                  setStoreToDelete(row)
                  setIsRequestDelete(true)
                  setDeleteModalVisible(true)
                },
                type: 'image',
              },
            ]
          : []),
      ]
    }
    else if(highest_role==="ADMIN"){
      return [
        {
          text: currentLanguage?.storeActions?.view_add_comments,
          className: 'view-add-comments',
          onClick: (row) => showModal(row),
          type: 'text',
        },
        {
          button: (row) => (
            <button
              className={`resubmit-btn ${
                row.resubmit_count >= 3 ? 'disabled' : ''
              }`}
              disabled={row.resubmit_count >= 3}
              type='button'
            >
              {currentLanguage?.storeActions?.resubmit} -{' '}
              <span className='text-FD853A text-14'>
                {' '}
                {row.resubmit_count}/3
              </span>
            </button>
          ),
          className: 'resubmit-btn',
          onClick: (row) => navigate(`/stores/resubmit-store/${row.id}`),
          type: 'button',
        },
      ]
    }
  } else if (status === 'pending') {
    if (highest_role === 'SUPERADMIN') {
      return [
        {
          text: currentLanguage?.storeActions?.update,
          className: 'view-add-comments',
          onClick: (row) => handleRequestOpenModal(row),
          type: 'text',
        },
      ]
    }
  }
}

export const viewOnlyStoreActions = (
  status,
  showModal,
  currentLanguage,
  readOnlyActionHint
) => {
  if (status === 'rejected') {
    return [
      {
        text: currentLanguage?.storeActions?.view_add_comments,
        className: 'view-add-comments',
        onClick: (row) => showModal(row),
        type: 'text',
        disabled: true,
        disabledTitle: readOnlyActionHint,
      },
    ]
  }
}

/** Read-only actions for market_role "2" (Business Viewer): View Product + View details only, no delete/edit */
export const getReadOnlyStoreActions = (
  status,
  handleProductOpenModal,
  handleRequestOpenModal,
  showModal,
  currentLanguage,
  readOnlyActionHint
) => {
  if (status === 'approved') {
    return [
      {
        text: currentLanguage?.storeActions?.view_product,
        className: 'view-add-comments',
        onClick: (row) => handleProductOpenModal(row),
        type: 'text',
      },
      {
        icon: '/store/viewicon.svg',
        className: 'view',
        onClick: (row) => handleRequestOpenModal(row),
        type: 'image',
      },
    ]
  }
  if (status === 'pending') {
    return [
      {
        text: currentLanguage?.storeActions?.update,
        className: 'view-add-comments',
        onClick: (row) => handleRequestOpenModal(row),
        type: 'text',
      },
    ]
  }
  if (status === 'rejected') {
    return [
      {
        icon: '/store/viewicon.svg',
        className: 'view',
        onClick: (row) => handleRequestOpenModal(row),
        type: 'image',
      },
      {
        text: currentLanguage?.storeActions?.view_add_comments,
        className: 'view-add-comments',
        onClick: (row) => showModal(row),
        type: 'text',
        disabled: true,
        disabledTitle: readOnlyActionHint,
      },
    ]
  }
  return []
}
